import { CopyResourceDc, ResourceType, ServiceInfoDc, TableInfoDc } from "@evergis/api";
import { RangeValue } from "@evergis/ui";

import { getLayerInfo } from "../layer/getLayerInfo";
import { getResourceName } from "../../../utils/resourceName";
import { createFilterCopyTask, FilterCopyTask } from "../tools/createFilterCopyTask";
import { TaskDataType } from "../../../interfaces/scheduler";
import { FilterConditionOperation } from "../../../components/LayerFilter/types";
import { i18n } from "../../../i18n";

type CopyJobInputResponse = [CopyResourceDc[], CopyResourceDc[], FilterCopyTask<TaskDataType.Table>[]];

interface CopyJobInputParams {
  layers: ServiceInfoDc[];
  tables: TableInfoDc[];
  copyTables?: boolean;
  inputCondition?: string;
  filter?: boolean;
  defaultScaleRange?: RangeValue;
}

export const getCopyJobInput = ({
  layers,
  tables,
  copyTables,
  inputCondition,
  filter,
  defaultScaleRange,
}: CopyJobInputParams): CopyJobInputResponse => {
  const innerTasks: FilterCopyTask<TaskDataType.Table>[] = [];
  const tableCopyResources: CopyResourceDc[] = [];

  const layerCopyResources: CopyResourceDc[] = layers
    ? layers.map((layer: ServiceInfoDc) => {
        const layerInfo = getLayerInfo(layer, defaultScaleRange);
        const layerTargetName: string = getResourceName();
        const tableTargetName: string = getResourceName();
        const { alias, name: sourceName } = layerInfo;

        if (copyTables) {
          const { tableName, condition } = layerInfo;
          const tableInfo: TableInfoDc = tables.find(item => item.name === layerInfo.tableName);
          const resultCondition = [inputCondition, filter ? condition : undefined]
            .filter(Boolean)
            .join(` ${FilterConditionOperation.AND} `);

          innerTasks.push(
            createFilterCopyTask({
              sourceName: tableName,
              targetName: tableTargetName,
              dataStorage: TaskDataType.Table,
              condition: resultCondition,
            }),
          );

          tableCopyResources.push({
            type: ResourceType.Table,
            name: tableName,
            copyName: tableTargetName,
            copyAlias: tableInfo && `${tableInfo.alias} ${i18n.t("bulkCopy.copy", { ns: "dialogs" })}`,
            copyWith: null,
          });
        }

        return {
          name: sourceName,
          type: ResourceType.Layer,
          copyName: layerTargetName,
          copyAlias: `${alias} копия`,
          copyWith: copyTables ? [tableTargetName] : null,
        };
      })
    : [];

  return [layerCopyResources, tableCopyResources, innerTasks];
};
